export enum onboardingPage {
    OTHER = 0,
    HOLIDAYS,
    STUDYDAYS,
    ACTIVITIES,
    TESTS
}